@import '../../stylesheets/defaults'

+host-styles('mp-toast')
  display flex

.icon-container-animated-fadeout
  // No `animation-duration`; will be set dynamically in template based on the `timeout` attr
  animation $ease-in-out timeout-animation both
  background-color var(--blue2)
  border-radius 3px
  height 36px
  left 4px
  position absolute
  transform-origin left
  width 36px


  &.error
    background-color var(--red1)

  &.destructive
    background-color var(--red1)

  &.info
    background-color var(--blue1)

  &.success
    background-color var(--green1)

  &.warning
    background-color var(--orange1)

.icon-container
  border-radius 3px
  display flex
  height 36px
  justify-content center
  width 36px
  svg-icon-style($white)

  svg-icon
    align-self center
    z-index $z-toast + 1 // needed to be above the fading background

  &.error
    background-color var(--negative-color)

  &.info
    background-color var(--blue1)

  &.success
    background-color var(--green1)

  &.warning
    background-color var(--orange1)

  &.timeout
    &.destructive
      background-color var(--red2)

    &.error
      background-color var(--red2)

    &.info
      background-color var(--blue2)

    &.success
      background-color var(--green2)

    &.warning
      background-color var(--orange2)

.mp-toast-body
  align-items center
  display flex
  padding-left 8px
  padding-right 8px

.mp-toast-stage
  position relative

  .mp-toast-container, .mp-toast-container *
    box-sizing border-box

  .mp-toast-container
    display flex
    opacity 1
    padding 0 0 16px 0
    position relative

    .mp-toast-widget
      align-items center
      background-color var(--inverted-component-background-color)
      border-radius 6px
      color var(--inverted-component-text-color)
      display flex
      font-family $family-helvetica
      font-size $font-size-medium
      font-weight $weight-bold
      height 44px
      padding 4px
      pointer-events auto
      position relative
      mp-drop-box-shadow()


      .mp-toast-message
        display flex
        flex-grow 1
        font-family $family-helvetica
        font-size $font-size-medium
        font-weight $weight-medium
        position relative

        a, a:visited
          color var(--inverted-blue1)
          text-decoration underline

      .mp-toast-actions
        display flex
        padding 0 16px

        &:empty
          display none

        a.mp-toast-action.mp-toast-cta
          color var(--inverted-component-text-color)

      .mp-toast-action
        cursor pointer
        font-family $family-helvetica
        font-size $font-size-medium
        font-weight $weight-medium
        margin-left 24px
        margin-right 0
        text-transform capitalize


        &:hover
          text-decoration underline

      .mp-toast-close
        cursor pointer
        display flex
        flex-direction row-reverse
        padding-left 8px
        svg-icon-style('%s' % var(--inverted-component-text-color))

// Animations
.mp-toast-container
  animation ($mp-slow)ms $ease-in-out container-animation both

.mp-toast-body
  // the second mp-slow delay is to wait to slide the container in until the initial container has faded in
  animation ($mp-slow)ms $ease-in-out ($mp-slow)ms body-slide-in-animation both

// When leaving, reverse the entire animation, so first slide out the text, then fade out the container
.mp-toast-out.mp-toast-container
  animation ($mp-slow)ms $ease-in-out ($mp-slow)ms fade-out-container-animation both

.mp-toast-out
  .mp-toast-body
    animation ($mp-slow)ms $ease-in-out body-slide-out-animation both


// keeps the body with no display at the beginning,
// then slides out the container and then renders children
@keyframes body-slide-in-animation
  0%
    display none
    max-width 0
    opacity 0
    padding 0

  50%
    opacity 0

  100%
    display flex
    max-width 1000px
    opacity 1

@keyframes body-slide-out-animation
  0%
    display flex
    max-width 1000px
    opacity 1

  50%
    opacity 0

  100%
    display none
    max-width 0
    opacity 0
    padding 0

// fade the element in to become bigger, and make it have a little "spring" as it finishes
@keyframes container-animation
  0%
    opacity 0
    transform scale(0)

  50%
    transform scale(1)

  60%
    transform scale(1.1)

  85%
    transform scale(0.95)

  100%
    opacity 1
    transform scale(1)

@keyframes fade-out-container-animation
  0%
    opacity 1
    transform scale(1)

  15%
    transform scale(0.95)

  40%
    transform scale(1.1)

  50%
    transform scale(1)

  100%
    opacity 0
    transform scale(0)

@keyframes timeout-animation
  0%
    max-width scaleX(1)
  100%
    transform scaleX(0)
